


























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component<SelectAllColumn>({
    name: 'SelectAllColumn',
})
export default class SelectAllColumn extends Vue {
    private checkAll: boolean = false;
    private isIndeterminate: boolean = false;

    @Prop({ required: true, type: String }) private prop!: string;
    @Prop({ required: true, type: String }) private label!: string;
    @Prop({ type: String, default: 'center' }) private align!: string;
    @Prop({ type: [String, Number], default: '' }) private width!: number | string;
    @Prop({ type: [String, Number], default: 60 }) private minWidth!: number | string;
    @Prop({ type: [Boolean, String], default: false }) private sortable!: boolean | string;
    @Prop({ required: true, type: Array}) private checkedList!: any[];
    @Prop({ required: true, type: Array}) private realValue!: any[];

    @Prop({ required: true, type: String}) private property!: string;

    get model() {
        return this.checkedList;
    }
    set model(v) {
        this.$emit('update:checkedList', v);
    }

    public handleCheckAll(val: boolean) {
        this.$emit('update:checkedList', val ? this.realValue.map((item) => item[this.property]) : []);
        this.isIndeterminate = false;
    }

    public handleChangeChecked(value: any) {
        const checkedCount = value.length;
        this.checkAll = checkedCount === this.realValue.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.realValue.length;
    }
}
